// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"415c74a4","34":"96ba04ca","728":"ae6c060a"}[chunkId] + ".chunk.css";
};